import { Result } from 'domain/types';

import readCSVLocationLinksClient from 'use-case/link/read/readCSVLocationLinksClient';
import readCSVLocationLinksCriteria from 'use-case/link/read/readCSVLocationLinksCriteria';
import { LocationLinkCSV } from 'domain/entity/location';

export type ReadCSVLocationLinksResult = Result<LocationLinkCSV[]>;
export type ReadCSVLocationLinks = (criteria: readCSVLocationLinksCriteria) => Promise<ReadCSVLocationLinksResult>;

export default (readCSVLinkClient: readCSVLocationLinksClient): ReadCSVLocationLinks => (
    criteria: readCSVLocationLinksCriteria
): Promise<ReadCSVLocationLinksResult> => readCSVLinkClient(criteria);
